// Shared line-item math helpers for Invoice Editor and bulk grid.
// Keeps per-each storage while letting UI display per-case when needed.

export const round2 = (num) => {
  const n = Number(num);
  if (!Number.isFinite(n)) return 0;
  return Math.round((n + Number.EPSILON) * 100) / 100;
};

export const rateToCode = (rate) => {
  const r = parseFloat(rate) || 0;
  if (r === 20) return 'S';
  if (r === 5) return 'R';
  if (r === 0) return 'Z';
  return 'O';
};

export const recalcLine = (item) => {
  const qtyCases = parseFloat(item?.quantity) || 0;
  const caseQty = parseFloat(item?.caseQuantity);
  const hasCaseQty = Number.isFinite(caseQty) && caseQty > 0;
  const unitsPerCase = hasCaseQty ? caseQty : 1;
  const rawUnitEach = parseFloat(item?.unitPrice);
  const hasUnitEach = Number.isFinite(rawUnitEach);
  const unitEach = hasUnitEach ? round2(rawUnitEach) : 0;
  const rate = parseFloat(item?.vatRate ?? 0) || 0; // percent

  // unitPrice is stored internally as per-each; net is always qty × case_qty × unit_each
  const basis = item?.priceBasis === 'case' ? 'case' : 'each';
  const net = round2(qtyCases * unitsPerCase * unitEach);
  const vatAmt = round2(net * (rate / 100));
  const gross = round2(net + vatAmt);

  return {
    ...item,
    unitPrice: hasUnitEach ? unitEach.toFixed(2) : '',
    caseQuantity: item?.caseQuantity || '',
    unitSize: item?.unitSize || '',
    priceBasis: basis,
    vatCode: item?.vatCode || rateToCode(rate),
    netTotal: net,
    vatAmount: vatAmt,
    total: gross
  };
};
